import { render, staticRenderFns } from "./OtifLastMonthShortcutCard.vue?vue&type=template&id=888e49a4&scoped=true&"
import script from "./OtifLastMonthShortcutCard.vue?vue&type=script&lang=js&"
export * from "./OtifLastMonthShortcutCard.vue?vue&type=script&lang=js&"
import style0 from "./OtifLastMonthShortcutCard.vue?vue&type=style&index=0&id=888e49a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "888e49a4",
  null
  
)

export default component.exports